// Row names bubble through the same handler as the row. Other embedded controls
// retain their native behavior, including auxiliary clicks and keyboard input.
const EMBEDDED_CONTROL = 'a,button,input,textarea,select,[contenteditable]:not([contenteditable="false"]),[role="button"],[role="link"],[role="checkbox"],[role="switch"]';

export function activateCollectionRow(event, url, onSelect) {
  if (event.defaultPrevented) return;
  const control = event.target.closest?.(EMBEDDED_CONTROL);
  if (control && control !== event.currentTarget && !control.hasAttribute("data-row-name")) return;
  if (event.type === "keydown") {
    if (event.key !== "Enter") return;
  } else if (event.type === "auxclick") {
    if (event.button !== 1) return;
  } else if (event.button != null && event.button !== 0) return;

  event.preventDefault();
  if (event.type === "auxclick" || event.metaKey || event.ctrlKey) {
    window.open(url, "_blank", "noopener,noreferrer");
  } else {
    onSelect();
  }
}
